import { FC } from 'react';
import style from './TenantSelectModal.module.css';
import { PopupTemplate } from '@/components/uiParts/Template/PopupTemplate/PopupTemplate';
import { SelectedTenant } from '@/config/initialState';
import { SwitchTargetTenant } from '@/types/api/tenantApi';

interface TenantSelectModalProps {
  opened: boolean;
  onClose: () => void;
  switchTargets: SwitchTargetTenant[];
  selectedTenant: SelectedTenant;
  onSelectTenant: (tenant: SwitchTargetTenant | null) => void;
  currentAffiliateId?: number;
  currentAffiliateName?: string;
}

export const TenantSelectModal: FC<TenantSelectModalProps> = ({
  opened,
  onClose,
  switchTargets,
  selectedTenant,
  onSelectTenant,
  currentAffiliateId,
  currentAffiliateName,
}) => {
  const handleTenantClick = (tenant: SwitchTargetTenant) => {
    // 元の所属法人を選択した場合は切り替え解除
    if (tenant.m_affiliate_id === currentAffiliateId) {
      onSelectTenant(null);
    } else {
      onSelectTenant(tenant);
    }
    onClose();
  };

  const isSelected = (tenant: SwitchTargetTenant) => {
    if (selectedTenant) {
      return tenant.m_affiliate_id === selectedTenant.m_affiliate_id;
    }
    // 切り替え中でなければ元の所属法人が選択状態
    return tenant.m_affiliate_id === currentAffiliateId;
  };

  // 所属法人は available_as_switch_target_flg の対象外で switchTargets に含まれない。
  // 切り替えを解除する導線として、常に先頭へ差し込む。
  // （所属法人自身が切り替え先として公開されている場合は二重表示になるため除外する）
  const displayTenants: SwitchTargetTenant[] = [
    ...(currentAffiliateId
      ? [
          {
            m_affiliate_id: currentAffiliateId,
            affiliate_name: currentAffiliateName || '',
          },
        ]
      : []),
    ...switchTargets.filter(
      (tenant) => tenant.m_affiliate_id !== currentAffiliateId,
    ),
  ];

  return (
    <PopupTemplate
      opened={opened}
      handleClose={onClose}
      title="ショッピング先を選ぶ"
    >
      <div className={style['modal-container']}>
        {displayTenants.length > 0 ? (
          <div className={style['tenant-list']}>
            {displayTenants.map((tenant) => (
              <button
                key={tenant.m_affiliate_id}
                type="button"
                className={`${style['tenant-item']} ${
                  isSelected(tenant) ? style['selected'] : ''
                }`}
                onClick={() => handleTenantClick(tenant)}
              >
                <div className={style['tenant-info']}>
                  <span className={style['tenant-name']}>
                    {tenant.affiliate_name}
                  </span>
                  {tenant.m_affiliate_id === currentAffiliateId && (
                    <span className={style['tenant-badge']}>所属法人</span>
                  )}
                  {tenant.industry && (
                    <span className={style['tenant-industry']}>
                      {tenant.industry}
                    </span>
                  )}
                </div>
                {isSelected(tenant) && (
                  <i className="icon-check" style={{ fontSize: 24 }} />
                )}
              </button>
            ))}
          </div>
        ) : (
          <div className={style['empty-message']}>
            切り替え可能な法人がありません
          </div>
        )}
      </div>
    </PopupTemplate>
  );
};
